export default "__VITE_ASSET__3bd1d9d2__"